import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import dropdown from '@/store/common/dropdown'
import creditClass from '@/store/credit-class'
import creditClassStudent from '@/store/credit-class-student'
import schedule from '@/store/schedule'
import turn from '@/store/turn'
import article from '@/store/article'
import creditClassMedia from '@/store/credit-class-media'
import studentCheckExamination from '@/store/student_check_examination'
import report from '@/store/report'
import diploma from '@/store/diploma'
import diplomaStudent from '@/store/diploma-student'
import studentCgpa from '@/store/student_cgpa'
import courseSemester from '@/store/course-semester'
import student from '@/store/student'
import accountFcmToken from '@/store/modules/account-fcm-token'
import notification from '@/store/modules/notification'
import forgotPassword from '@/store/forgot-password'
import curriculumVitae from '@/store/curriculum-vitae'
import payment from '@/store/payment'
import programme from '@/store/programme'
import programmeSubject from '@/store/programme-subject'
import programmeSubjectGroup from '@/store/programme-subject-group'
import digitalLibrary from '@/store/digital-library'
import setOfCriteriaObject from '@/store/set-of-criteria-object'
import studentEvaluate from '@/store/student-evaluate'
import registerSubject from './modules/register-subject'

import layout from './layout'
import study from './modules/study'
import auth from './modules/auth'
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'
import credentialSearch from '@/store/credential-search'
import credentialOfStudent from '@/store/credential-of-student'
import credentialCondition from '@/store/credential-condition'
import credentialProcessHistory from '@/store/credential-process-history'
import registerGraduationProject from '@/store/register-graduation-project'
import registerGraduation from '@/store/register-graduation'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    layout,
    study,
    registerSubject,
    dropdown,
    creditClass,
    creditClassStudent,
    schedule,
    turn,
    article,
    studentCheckExamination,
    report,
    diploma,
    diplomaStudent,
    studentCgpa,
    courseSemester,
    creditClassMedia,
    student,
    accountFcmToken,
    notification,
    curriculumVitae,
    forgotPassword,
    payment,
    programme,
    programmeSubject,
    programmeSubjectGroup,
    digitalLibrary,
    setOfCriteriaObject,
    studentEvaluate,
    credentialSearch,
    credentialOfStudent,
    credentialCondition,
    credentialProcessHistory,
    registerGraduationProject,
    registerGraduation,
  },
  strict: process.env.DEV,
})
